import React from "react";
import { motion } from "framer-motion";
import { useLocation } from "react-router-dom";
export default function FadeRight({ children }) {
  const { pathname } = useLocation();
  return (
    <motion.div
      key={pathname}
      initial={{ opacity: 0, x: -10 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.5 }}
      exit={{ opacity: 0, x: -10 }}
    >
      {children}
    </motion.div>
  );
}
